import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { provinceAndCityAdminContext } from "../../../context/Admin/ProvinceAndCityAdminContext/ProvinceAndCityAdminContext";

const ProvinceAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const {
    provinces,
    id,
    name,
    setName,
    isShowModal,
    handleShowModal,
    handleCloseModal,
    handleGetProvinces,
    handleCreateProvince,
    handleEditProvince,
    handleDeleteProvince,
  } = useContext(provinceAndCityAdminContext);

  useEffect(() => {
    handleGetProvinces();
  }, []);

  return (
    <>
      <SiteTitle title="استان" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "استان", type: "a" },
        ]}
        title="آیتم های استان"
      />

      <CardLayout>
        {permission.province_create_update && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        {isEmpty(provinces) ? (
          <EmptyData />
        ) : (
          <Table responsive hover borderless striped>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>شناسه</th>
                <th>نام</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {provinces.map((_item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{_item.id}</td>
                  <td>{_item.name}</td>
                  <td className="mw-25">
                    {permission.province_create_update && (
                      <button
                        onClick={() => handleShowModal(_item)}
                        className="btn btn-primary mr-2"
                      >
                        ویرایش
                      </button>
                    )}
                    {permission.province_delete && (
                      <i
                        onClick={() =>
                          areYouSureMessage(
                            () => handleDeleteProvince(_item.id),
                            `آیا از حذف ${_item.name} اطمینان دارید؟`
                          )
                        }
                        className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} استان`}
        show={isShowModal}
        onHide={handleCloseModal}
      >
        <form
          onSubmit={id ? handleEditProvince : handleCreateProvince}
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="name">نام</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
      </CustomModal>
      {/* End Create Modal */}
    </>
  );
};

export default ProvinceAdmin;
